<div *ngIf="showRequest" class="">
  <h2 class="sectionTitle">{{'ADMIN_USER.E_TENDER_FORM.CANCEL_TENDER' | translate }}</h2>
  <form [formGroup]="cancelTenderForm">
    <div class="form-container" #cancelTender>
      <!--cancellation reason -->
      <div class="form-group">
        <label for="CancellationReason">{{ 'ADMIN_USER.E_TENDER_FORM.CANCELLATION_REASON' | translate}}</label>
        <span class="red"> *</span>
        <textarea formControlName="CancellationReason" name="CancellationReason" class="form-control"></textarea>
        <div *ngIf="submitted && Validate.CancellationReason?.errors" class="red ">
          <div *ngIf="Validate.CancellationReason?.errors?.required">
            {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          <div *ngIf="Validate.CancellationReason?.errors?.maxlength">
            {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
          </div>
        </div>
      </div>
      <!--attachments-->
      <div class="form-group">
          <label>{{'ADMIN_USER.E_TENDER_FORM.ATTACHMENTS'|translate}}</label>
          <input type="file" class="form-control" MaxSizeInMB="50" accept=".pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx,.rar"
            id="CancellationAttachments" formControlName="CancellationAttachments"
            (change)="AddAttachmentFile($event, Validate.CancellationAttachments, 'CreateTender_CancellationAttachments', ETenderAttachmentType.CancellationAttachment, 'AttachmentProgress')" />
          <div class="upload-info">
            <span>{{'ADMIN_USER.SHARED.ETENDER_ALLOWED_FILE_EXTENSIONS' | translate}}</span>
          </div>
          <div class="progress">
            <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
              [style.width]="AttachmentProgress + '%'">
              <span class=""> {{AttachmentProgress}} % Complete</span>
            </div>
          </div>
        </div>
    </div>
    <div class="form-group">
        <button [disabled]="loading" class="btn btn-primary SCAcustomBtn" Confirmation (confirmationClick)="onSubmit()">{{ 'FRONT_USER.SAVE' | translate}}</button>
      </div>
  </form>
</div>

<div *ngIf="!showRequest" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'ADMIN_USER.E_TENDER_FORM.CANCEL_TENDER_SUCCESS_MESSAGE' | translate }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/TenderList">
        {{ 'ADMIN_USER.E_TENDER_FORM.TENDER_LIST' | translate }}</a></p>
  </div>
</div>